<div class="row d-flex justify-content-between">
    <div class="col-md-12 divDownload">
        <button mat-mini-fab class="excel" (click)="DownLoadItemsExcelReport()">
            <i-tabler name="file-type-xls" class="routeIcon"></i-tabler>
        </button>

        <button mat-mini-fab class="pdf" (click)="DownLoadItemsPDFReport()">
            <i-tabler name="file-type-pdf" class="routeIcon"></i-tabler>
        </button>
    </div>
</div>

<div class="count" *ngIf="AllItems?.length!=0">{{'Results'| translate}}: {{AllItems.length}}</div>
<div class="row">
    <div *ngIf="AllItems?.length==0;then NoItems else Items"></div>

    <ng-template #NoItems>
        <div class="col-md-12">
            <p> {{ 'NoDataFound' | translate }}</p>
        </div>
    </ng-template>

    <ng-template #Items>
        <div class="col-lg-4 col-sm-4 m-b-15" *ngFor="let item of AllItems">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow card2 position-relative card-hover">
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                    <mat-card-title class="mat-mdc-card-title text-white">
                        {{ item.productName| subString:20 }}
                    </mat-card-title>
                    <div class="d-flex divIcons" *ngIf="showEdit">
                        <i-tabler name="trash" class="icon-20 d-flex clickIcon"
                            (click)="DeleteItem(item.productId)"></i-tabler>
                        <i-tabler name="edit" class="icon-20 d-flex clickIcon"
                            (click)="EditItem(item.productId)"></i-tabler>
                        <i-tabler name="eye" class="icon-20 d-flex clickIcon"
                            (click)="ViewItem(item.productId)"></i-tabler>
                    </div>
                </mat-card-header>
                <img alt="{{item.productName}}" width="50%" height="50%" class="mat-mdc-card-image mdc-card__media"
                    src="{{item.imgURL | adjust_image_path}}" (click)="ShowImage(item)">
                <mat-card-content class="mat-mdc-card-content p-y-24">
                    <ul>
                        <li><span class="span-title">{{'Color'|translate}} : </span><span>{{item?.colorName}} </span>
                        </li>
                        <li><span class="span-title">{{'Category'|translate}} : </span><span>{{item?.categoryName}}
                            </span>
                        </li>
                        <li><span class="span-title">{{'metersPerRod'|translate}} : </span>
                            <span>{{item?.metersPerRod??1}} {{ 'Meter'|translate }}</span>
                        </li>
                        <li><span class="span-title">{{'pricePerOne'|translate}} : </span>
                            <span>{{item?.pricePerOne}} {{ 'EGP' | translate}}</span>
                        </li>
                        <li><span class="span-title">{{'TotalQuota'|translate}} : </span><span>{{item?.totalQuota}}
                            </span>
                        </li>
                        <li><span class="span-title">{{'measruingUnit'|translate}} :
                            </span><span>{{item?.typeOfProductName}}
                            </span></li>
                    </ul>
                </mat-card-content>
            </mat-card>
        </div>
    </ng-template>
</div>
